import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
	const token = localStorage.getItem("maytra");

	if (token !== null) return children;
	else return <Navigate to="/login" />;
};

export default PrivateRoute;
